import { Component, Input } from '@angular/core';

import { getFilterSolid, getPathConfig } from '../power-state.utils';

@Component({
  selector: 'app-power-state-mode-zero',
  templateUrl: './power-state-mode-zero.component.html',
  styleUrls: ['./power-state-mode-zero.component.scss'],
})
export class PowerStateModeZeroComponent {

  @Input() showPowerFlow?: boolean;
  @Input() bgTextColor = 'white';
  @Input() unitLabel = 'Unit';
  @Input() unitSymbol = 'W';
  @Input() valuePrecision = 0;
  @Input() duration = 3;
  @Input() fontSize = 3;
  @Input() fromSolarToHome?: number;

  readonly getFilterSolid = (color = this.bgTextColor) => getFilterSolid(color);

  readonly getPathConfig = (params: object, duration = this.duration) =>
    getPathConfig(params, duration);
}
